import React, { useState } from 'react';
import { FiKey, FiLock } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const DEFAULT_ACCESS_CODE = 'LOTO2025';

function AdminLogin({ onAuthenticated }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (code.trim() === DEFAULT_ACCESS_CODE) {
      setError(false);
      setCode('');
      onAuthenticated();
      return;
    }

    setError(true);
  };

  return (
    <form className="admin-login-box" onSubmit={handleSubmit}>
      <div className="admin-icon-bubble">
        <SafeIcon icon={FiLock} />
      </div>

      <h3>ACCES ADMIN &amp; STATISTICI</h3>
      <p>
        Introdu codul de autorizare pentru a accesa datele de sistem și baza de extrageri.
      </p>

      <div className="input-group">
        <SafeIcon icon={FiKey} />
        <input
          type="password"
          placeholder="Cod de acces"
          value={code}
          onChange={(event) => {
            setCode(event.target.value);
            setError(false);
          }}
          autoComplete="current-password"
          aria-label="Cod de acces administrator"
          autoFocus
        />
      </div>

      {error && (
        <span className="auth-error" role="alert">
          Cod de acces incorect.
        </span>
      )}

      <button type="submit" className="admin-btn-primary">
        AUTENTIFICARE LOCALĂ ↗
      </button>
    </form>
  );
}

export default AdminLogin;